"use client";

import React from "react";

import Image from "next/image";
import { PortableText } from "@portabletext/react";
import { customRichTextComponent } from "@/sanity/sanityPortableText";

import Video from "@/components/global/Video";

import { PageEventSchema } from "@/sanity/pages/PageEventTemplate";

import videoFlare from "@/public/frankfurt-event/videoFlare.png";

export default function VideoSection({ data }: { data: PageEventSchema }) {
  return (
    <section className="relative pb-[4rem] lg:pb-[24rem] overflow-x-clip">
      <div className="px-[2rem] w-[min(152.5rem,100%)] mx-auto">
        <div className="relative flex flex-col items-center">
          <Image
            className="w-[80rem] sm:w-[120rem] lg:w-[200rem] absolute left-1/2 -translate-x-1/2 top-[90%] -translate-y-[200%] lg:-translate-y-[60%] lg:top-[20%] max-w-[unset] pointer-events-none"
            src={videoFlare}
            alt=""
          />

          {data?.videoTitle && (
            <PortableText
              value={data?.videoTitle ?? []}
              components={customRichTextComponent({
                block: {
                  h2: ({ children }) => (
                    <h2 className="gradient-title relative text-[4rem] lg:text-[7rem] leading-[1.1em] font-[600] text-white w-[min(90rem,100%)] text-center mb-[1rem] lg:mb-[2rem]">
                      {children}
                    </h2>
                  ),
                  h6: ({ children }) => (
                    <h6 className="rounded-full uppercase px-[2rem] py-[1rem] font-bold leading-[1em] text-[1.75rem] bg-[#1A1A1AB2] bg-opacity-10 border border-white border-opacity-20 backdrop-blur-[2rem] mb-[1rem]">
                      {children}
                    </h6>
                  ),
                  normal: ({ children }) => (
                    <p className="text-white font-[400] text-[2rem] text-center mb-[3rem] relative z-[2] px-[4rem] lg:px-0">
                      {children}
                    </p>
                  ),
                },
              })}
            />
          )}

          <div className="w-full rounded-[1rem] lg:rounded-[2rem] bg-gradient-to-b from-[#61FFCE]/30 to-[#007A5A]/30 p-[.5rem] md:p-[1rem] relative after:absolute after:bg-gradient-to-r after:from-transparent after:via-[#55EABD] after:to-transparent after:h-[2rem] after:w-[70%] after:top-0 after:left-1/2 after:-translate-x-1/2">
            <div className="overflow-clip rounded-[.5rem] relative z-10 flex *:!w-full">
              <Video videoData={data?.video} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
